import { MainLayoutContainer } from "components/Layout";
import { useAnswerDetail } from "./useAnswerDetail";
import {
  Box,
  CardContent,
  Grid2 as Grid,
  Stack,
  Typography,
  Divider,
  Chip,
} from "@mui/material";
import { CardOutline } from "components/Card";

export const AnswerDetail = () => {
  const {
    answer,
    loading,
    organizationId,
  } = useAnswerDetail();

  if (loading || !answer) {
    return <div>loading...</div>;
  }

  return (
    <MainLayoutContainer
      title="Answer Details"
      loading={loading}
    >
      <Box mt={2}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <CardOutline>
              <CardContent>
                <Typography gutterBottom component="div" fontWeight={600} variant="h6">
                  Question
                </Typography>
                <Box mt={2}>
                  <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                    <Chip
                      label={
                        answer.question?.type === "multiple_choice"
                          ? "Multiple Choice (select multiple)"
                          : answer.question?.type === "single_choice"
                          ? "Multiple Choice (select one)"
                          : answer.question?.type === "likert"
                          ? "Likert Scale"
                          : "Fill in the blank"
                      }
                      size="small"
                      color={
                        answer.question?.type === "multiple_choice"
                          ? "secondary"
                          : answer.question?.type === "single_choice"
                          ? "info"
                          : "default"
                      }
                    />
                  </Stack>
                  <Typography variant="h6" fontWeight={600} gutterBottom>
                    {answer.question?.title || "Untitled Question"}
                  </Typography>
                  {answer.question?.body && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                      {answer.question.body}
                    </Typography>
                  )}
                </Box>
              </CardContent>
            </CardOutline>
          </Grid>

          <Grid size={12}>
            <CardOutline>
              <CardContent>
                <Typography gutterBottom component="div" fontWeight={600} variant="h6">
                  Answer
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Box mt={2}>
                  {answer.option ? (
                    <Stack spacing={1}>
                      <Typography variant="body1" fontWeight={600}>
                        Selected Option:
                      </Typography>
                      <Typography variant="body1">
                        {answer.option.text}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        Answer Text: {answer.answer}
                      </Typography>
                    </Stack>
                  ) : (
                    <Typography variant="body1">
                      {answer.answer}
                    </Typography>
                  )}
                </Box>
              </CardContent>
            </CardOutline>
          </Grid>
        </Grid>
      </Box>
    </MainLayoutContainer>
  );
};
